import { Chip, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { handleFilterChipClick } from "../modules/OrganizationQuickTales/hooks/QuickTalesHooks";

const FilterModalTextSection = ({
  filterOptions,
  setFilterOptions,
  title,
  currentOptions,
}) => {
  const [options, setOptions] = useState(currentOptions);

  useEffect(() => {
    const updatedOptions = options.map((option) => {
      // Check if the option's label is in filterOptions
      return {
        ...option,
        selected: filterOptions.includes(option.label),
      };
    });
    // Update the options state
    setOptions(updatedOptions);

    if (filterOptions.length === 0) {
      let temp = [...options];
      temp.forEach((item, index) => {
        if (index === 0) temp[index].selected = true;
        else temp[index].selected = false;
      });
      setOptions(temp);
    }
  }, [filterOptions]);

  return (
    <Grid item container direction={"column"} style={{ paddingLeft: 10 }}>
      <div style={titleStyles}>{title}</div>
      <Grid container style={{ paddingTop: 16 }}>
        {Array.isArray(options) &&
          options.map((item, index) => (
            <Chip
              label={item.label}
              color={item.selected ? "primary" : undefined}
              style={item.selected ? selectedChipStyles : chipStyles}
              key={index}
              onClick={() =>
                handleFilterChipClick(
                  index,
                  options,
                  setOptions,
                  setFilterOptions
                )
              }
            />
          ))}
      </Grid>
    </Grid>
  );
};

export default FilterModalTextSection;

const titleStyles = {
  color: "#020303",
  fontSize: 16,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};

const chipStyles = {
  marginRight: 10,
  fontWeight: 500,
  fontSize: 14,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
  textTransform: "capitalize",
};
const selectedChipStyles = {
  marginRight: 10,
  fontWeight: 500,
  fontSize: 14,
  backgroundColor: "#00A7CD",
  paddingLeft: 10,
  paddingRight: 10,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
  textTransform: "capitalize",
};
